import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTIONS_INELIGIBLE_PETITION_REFUNDS_ENABLED = createFcmDetails(
	'promotions_ineligible_petition_refunds_enabled',
	{
		owner: 'Site Platform',
		context: 'Automated Refunds on Closed / Hidden Petitions - Promotion Service',
		import: false,
		description: `
			Enables / Disables the 60 day automated refunds for closed / hidden petitions.
			When a petition is closed or hidden the RefundIneligiblePetition worker is queued up to refund the petition in 60 days.
			At the time of processing the petition, this FCM is checked to see if automated refunds are still enabled.
		`,
	},
);
